export interface FavouriteVehicleMetadata {
  id: string
  url: string
}

export const SESSION_STORAGE_KEY = 'oxford-favourite-vehicle'

export const storePreAuthFavourite = (metadata: FavouriteVehicleMetadata) => {
  sessionStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(metadata))
}
